import React from 'react';
import { View } from 'react-native';

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { Badge, Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { REQUEST_STATUS } from '../../../Requests/Utils/Enums';
import { getBadgeLabel } from '../../../Requests/Utils/Helpers';
import { getThemeImages as getSohoThemeImages } from '../../../Themes/Modes';

import styles from './RequestBodyItem.Styles';

const RequestBodyItem = ({
  title,
  icon,
  status,
  isSohoUser,
  subtitle,
  subtitlePlaceHolders,
  renderRightSideContent,
}) => {
  const theme = useTheme();
  const sohoImages = getSohoThemeImages(theme.name);

  const renderCardBody = () => {
    return (
      <View>
        <VFText
          style={styles.bodyDescriptionStyle}
          i18nKey={subtitle}
          placeHolders={subtitlePlaceHolders}
        />
      </View>
    );
  };

  const renderBadge = () => {
    if (status === REQUEST_STATUS.PENDING) {
      return null;
    }
    let _type;
    switch (status) {
      case REQUEST_STATUS.COMPLETED:
        _type = 'positive';
        break;
      case REQUEST_STATUS.CANCELLED:
        _type = 'neutral';
        break;
      case REQUEST_STATUS.REJECTED:
        _type = 'critical';
        break;
      default:
        break;
    }

    return <Badge type={_type} text={getBadgeLabel(status)} />;
  };

  return (
    <>
      <View style={styles.container}>
        <View style={styles.bodySection}>
          {!isSohoUser && (
            <Icon
              style={styles.icon}
              name={icon ?? sohoImages.ic_business}
              type="image"
              size={35}
            />
          )}
          <View style={styles.bodySectionText}>
            {!isSohoUser && <VFText style={[styles.bodySectionTopText]} i18nKey={title} />}
            {renderCardBody()}
          </View>
        </View>
        {_isFunction(renderRightSideContent) ? renderRightSideContent() : renderBadge()}
      </View>
    </>
  );
};

RequestBodyItem.defaultProps = {
  requestStatus: null,
};

RequestBodyItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  subtitlePlaceHolders: PropTypes.arrayOf(PropTypes.string),
  icon: PropTypes.string,
  status: PropTypes.oneOf(REQUEST_STATUS),
  images: PropTypes.object,
  renderRightSideContent: PropTypes.func,
  isSohoUser: PropTypes.bool,
};

export default RequestBodyItem;
